export const DEFAULT_METRICS_RANGE_DAYS = 30;

export type MetricsDateRange = {
  from: string;
  to: string;
};

export function formatMetricsDate(date: Date): string {
  return date.toISOString().slice(0, 10);
}

export function subtractDays(date: Date, days: number): Date {
  const next = new Date(date);
  next.setUTCDate(next.getUTCDate() - days);
  return next;
}

export function defaultMetricsDateRange(now = new Date()): MetricsDateRange {
  const to = formatMetricsDate(now);
  const from = formatMetricsDate(subtractDays(now, DEFAULT_METRICS_RANGE_DAYS));
  return { from, to };
}

export function metricsPresetRange(
  days: number,
  now = new Date(),
): MetricsDateRange {
  return {
    from: formatMetricsDate(subtractDays(now, days)),
    to: formatMetricsDate(now),
  };
}

export function formatMetricsRangeLabel(from: string, to: string): string {
  const fromDate = new Date(`${from}T00:00:00Z`);
  const toDate = new Date(`${to}T00:00:00Z`);
  if (Number.isNaN(fromDate.getTime()) || Number.isNaN(toDate.getTime())) {
    return `${from} – ${to}`;
  }

  const sameYear = fromDate.getUTCFullYear() === toDate.getUTCFullYear();
  const fromLabel = fromDate.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    ...(sameYear ? {} : { year: "numeric" }),
  });
  const toLabel = toDate.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  return `${fromLabel} – ${toLabel}`;
}

export function isValidMetricsDateRange(from: string, to: string): boolean {
  if (!from || !to) {
    return false;
  }
  return from <= to;
}
